import { ArrowUUpRight, SignOut, Trash, UserGear } from "@phosphor-icons/react";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useCustomer from "common/datahooks/useCustomer";
import type { Member } from "common/types";

import type { ElementType } from "react";

import EnvelopeX from "assets/icons/envelope-x.svg?react";

export default function useMembersActions(member: Member) {
  const { permissions } = useSelectedWorkspaceContext();
  const { customerInfo } = useCustomer();
  const { email: customerEmail } = customerInfo;
  const { email, status, role } = member;

  const isCustomerWorkspace = customerEmail === email;

  let actions: Partial<
    Record<
      "resend" | "revoke" | "permissions" | "remove",
      { icon: ElementType; label: string; isDanger?: true }
    >
  > = {};

  if (role !== "owner") {
    if (isCustomerWorkspace) {
      actions = {
        remove: { icon: SignOut, label: "Leave workspace", isDanger: true },
      };
    } else if (permissions.includes("members_full")) {
      actions =
        status === "pending"
          ? {
              resend: {
                icon: ArrowUUpRight,
                label: "Resend invite",
              },
              revoke: {
                icon: EnvelopeX,
                label: "Revoke invite",
                isDanger: true,
              },
            }
          : {
              permissions: { icon: UserGear, label: "Update permissions" },
              remove: {
                icon: Trash,
                label: "Remove from workspace",
                isDanger: true,
              },
            };
    }
  }

  return {
    actions,
  };
}
